export default __webpack_public_path__ + "static/media/1840_1842.a2388688.jpg";